import React, { useEffect } from 'react';
import { BasicContainer, ContainerFull } from '../../UI/ContentContainer';
import PageTitle from '../../UI/PageTitle';
import TextContent from '../../UI/TextContent';
import { Typography, Box, Container, Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

import MenuBookIcon from '@mui/icons-material/MenuBook';


import work from '../../../assets/img/work.png';
import office from '../../../assets/img/office.png';
import {ReactComponent as TraShape} from '../../../assets/svg/cross_shape.svg';

import Process from './Process';
import SmoFoldList from '../SmoPage/SmoFoldList';
import Payment from '../../common/Payment';

// aos
import AOS from "aos";
import "aos/dist/aos.css";
import { BoxCard, JobResponse } from '../../UI/List/List';
import MetaTags from '../../MetaTags/MetaTags';

const TABLE_DATA = [
    {
        id: 1,
        title: 
            <div >
                <p>법 제15조제1항을 위반하여 사업장을 실질적으로 총괄하여 관리하는 사람으로 하여금 업무를 총괄하여 관리하도록 하지 않은 경우</p>
            </div>,
        subtitle: '제재사항',
        tableHead: ['세부내용', '1차', '2차', '3차'],
        data: [
            [
                '법 제175조 제5항 제1호', 300, 400, 500
            ],
        ]
    },
    {
        id: 2,
        title: 
            <div>
                <p>법 제16조제1항을 위반하여 관리감독자에게 직무와 관련된 산업 안전 및 보건에 관한 업무를 수행하도록 하지 않은 경우</p>
            </div>,
        subtitle: '제재사항',
        tableHead: ['세부내용', '1차', '2차', '3차'],
        data: [
            [
                '법 제175조 제5항 제1호', 300, 400, 500
            ],
        ]
    },
    {
        id: 3,
        title: 
            <div>
                <p>법 제17조제1항을 위반하여 안전관리자의 업무를 수행하도록 하지 않은 경우</p>
            </div>,
        subtitle: '제재사항',
        tableHead: ['세부내용', '1차', '2차', '3차'],
        data: [
            [
                '법 제175조 제5항 제1호', 300, 400, 500
            ],
        ]
    },
    {
        id: 4,
        title:'참고',
        subtitle: '',
        tableHead: ['안전보건관리체제', '업무내용(위험성평가 관련 내용만 발췌)'],
        data: [
            [
                '안전보건관리책임자','위험성평가의 실시에 관한 사항'
            ],
            [
                '관리감독자','위험성평가에 관한 다음 각 목의 업무 가. 유해·위험요인의 파악에 대한 참여 나. 개선조치의 시행에 대한 참여'
            ],
            [
                '안전관리자·보건관리자','위험성평가에 관한 보좌 및 지도·조언'
            ],
        ]
    }
]




const traShpeColor = '#eaf1ff';


const RaPage = () => {

    useEffect(() => {
        AOS.init({
            duration: 1500
        })
    })


    return (
        <BasicContainer>
            <MetaTags
                title="위험성평가"
                description="위험성평가에 대해 소개 합니다."
                ogtitle="드림산업안전센터(주)-위험성평가"
                ogdescription="위험성평가에 대해 소개 합니다."
            />
            <PageTitle title="위험성평가"/>
            <TextContent title="위험성 평가란?">
            <Typography variant="description" component="p" data-aos="fade-up">
                사업주는 건설물, 기계·기구·설비, 원재료, 가스, 증기, 분진, 
                근로자의 작업행동 또는 그 밖의 업무로 인한 유해·위험 요인을 
                찾아내어 부상 및 질병으로 이어질 수 있는 위험성의 크기가 
                허용 가능한 범위인지를 평가하여야 하고, 그 결과에 따라 
                관계법령에 의한 조치와 더불어 근로자에 대한 위험 또는 
                건강장해를 방지하기 위하여 필요한 경우 추가적인 조치를 하여야 하며, 
                위험성평가를 실시한 경우에는 평가의 결과와 조치사항을 기록·보존하도록 되어 있음.
            </Typography>
            <Typography variant="reference" component="span" sx={{display: "flex", alignItems: "center"}} data-aos="fade-up"><MenuBookIcon/>[산업안전보건법 제36조]</Typography>
            
            </TextContent>

            <TextContent maxWidth="lg">
                <Grid container  justifyContent={'space-between'}>
                    <Grid xs={12} sm={5} md={4} data-aos="fade-right">
                        <img src={work} alt="work" style={{borderRadius: '10px', width:'100%'}}/>
                    </Grid>
                    <Grid xs={12} sm={7} md={7} >
                        <Typography variant="subTitle" component="h2">위험성평가 지원(KRAS방식)</Typography>
                        <Typography variant="description" component="p" sx={{lineHeight: "2"}} data-aos="fade-left">
                            2013년부터 위험성 평가가 법제화 됨에 따라 사업장의 잠재된 유해·위험요인을 파악하고, 개선대책을 수립하여 안전하고 쾌적한 작업환경 조성을 위하여 최고의 기술력과 경험을 바탕으로 위험성평가(인정) 업무 지원 및 컨설팅 실시
                        </Typography>
                    </Grid>

                </Grid>

            </TextContent>


            <Box style={{position:'relative'}}>
                <Box style={{position:'absolute', top: '-2px', width: '100%', transform: 'scale(-1,-1)'}}>
                    <TraShape style={{fill: 'white' }}/>
                </Box>
            </Box>
            <Process style={{backgroundColor: traShpeColor}}/>

            <Box style={{position:'relative'}}>
                <Box style={{position:'absolute', bottom: '-2px', width: '100%', transform:'scaleX(-1)'}}>
                    <TraShape style={{fill: '#023692' }}/>
                </Box>
            </Box>

            <TextContent title="위험성평가 실시 시기" maxWidth="md" styleTitle={{color:'white'}} sectionStyle={{backgroundColor: '#023692'}}>
                <Card elevation={1} data-aos="fade-up">
                    <CardContent>
                        <BoxCard 
                            title="위험성평가는 최초평가 및 수시평가, 정기평가로 구분하여 실시"
                            description={['- 최초평가 및 정기평가는 전체 작업을 대상으로 실시']}
                        />
                        <BoxCard 
                            title="정기평가는 최초평가 후 매년 정기적으로 실시"
                        />

                        <BoxCard 
                            title="수시평가 실시 사유"
                            description={[
                                '- 사업장 건설물의 설치·이전·변경 또는 해체',
                                '- 기계·기구, 설비, 원재료 등의 신규 도입 또는 변경',
                                '- 건설물, 기계·기구, 설비 등의 정비 또는 보수',
                                '- 작업방법 또는 작업절차의 신규 도입 또는 변경',
                                '- 중대산업사고 또는 산업재해(휴업 이상의 요양을 요하는 경우에 한정한다) 발생',
                                '- 그 밖에 사업주가 필요하다고 판단한 경우'
                            ]}
                        />

                    </CardContent>
                </Card>

            </TextContent>

            <ContainerFull>
                <Container maxWidth="lg">
                    <Typography variant="subTitle" component="h2" textAlign='center'>
                        업무 내용
                    </Typography>
                    <Typography 
                        variant="description" 
                        component="p" 
                        textAlign='center'
                        marginBottom='2rem'
                        data-aos="fade-up"
                    >
                        위험성 평가를 체계적으로 수행할 수 있도록, 구체적인 실행 방법과 절차에 대한 가이드라인을 제공합니다
                    </Typography>
                    
                    <Grid container
                        justifyContent='center'
                        alignItems='center'
                        spacing={2}
                    >
                        <Grid 
                            md={6}
                        >
                            <img src={office} alt="office" style={{maxWidth:'100%'}}/>
                        </Grid>
                        <Grid
                            md={6}
                            display='flex'
                            flexDirection='column'
                            gap='10px'
                        >
                            <JobResponse 
                                title="위험성평가를 할 수 있도록 위험성평가의 실시 방법·절차 지원"
                                
                            />
                            <JobResponse 
                                title="소규모 사업장의 위험성평가 인정 신청방법 및 심사방법 지원"
                            />
                            <JobResponse 
                                title="위험성평가를 실시할 수 있도록 하기 위한 교육·컨설팅 지원"
                            />
                        </Grid>
                    </Grid>
                </Container>
            </ContainerFull>

            {/* <TextContent title='용역 대가' maxWidth='md'>
                <Payment
                    description="「엔지니어링산업 진흥법」제31조제2항의 규정에 따라 다음 사항을 고려하여 견적금액을 산출"
                >
                    <Typography variant="description" component="p" sx={{padding: '5px'}} lineHeight='1.2'>- 사업장 인원(건설현장의 규모)</Typography>
                    <Typography variant="description" component="p" sx={{padding: '5px'}} lineHeight='1.2'>- 기계·기구 및 설비현황</Typography>
                    <Typography variant="description" component="p" sx={{padding: '5px'}} lineHeight='1.2'>- 상시 근로자수 100인 미만 사업장의 경우 인정·비인정 신청 여부(인정제도 참여여부)</Typography>
                    <Typography variant="description" component="p" sx={{padding: '5px'}} lineHeight='1.2'>- 원청과 협력업체간 안전보건 공생협력프로그램 실시 여부</Typography>
                </Payment>
            </TextContent> */}

            <TextContent title="법적제재사항" data-aos="fade-up">
                <Typography variant="contentTitle" component="h3">위반시 법적 제재 사항</Typography>
                <Typography variant="contentTitleSmall" component="h4">산업안전보건법 시행령 별표 35(과태료의 부과기준)</Typography>
                <div style={{display: "flex", flexDirection:"column", gap: "10px"}}>
                {
                    TABLE_DATA.map(data => (
                        <SmoFoldList 
                            key={data.id}
                            titleSx={{whiteSpace: 'pre-line'}}
                            title={data.title}
                            subtitle={data.subtitle}
                            thead={data.tableHead}
                            data={data.data}
                        />
                    ))
                }

                </div>

            </TextContent>

        </BasicContainer>
    )
}

export default RaPage;